import { render, staticRenderFns } from "./menuOperDesign.vue?vue&type=template&id=5e58ad5d&scoped=true"
import script from "./menuOperDesign.vue?vue&type=script&lang=js"
export * from "./menuOperDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58ad5d",
  null
  
)

export default component.exports